<template>
  <div v-if="!recreating" class="form-flex">
    <date-picker :disabled="disabled" v-model="date" :options="options"/>
    <a v-if="isCleanable" :disabled="disabled" class="form-addon btn btn--default" @click="clear">
      <i class="icon-eraser"></i>
    </a>
  </div>
</template>

<script>
  export default {
    data: () => ({
      date: null,
      recreating: false
    }),
    mounted () {
      if (this.value) {
        this.date = [this.value]
      }
    },
    methods: {
      clear () {
        this.date = null
        this.$emit('input', null)
        this.recreating = true
        setTimeout(() => {
          this.recreating = false
        })
      }
    },
    computed: {
      options () {
        const format = 'd/m/Y' + (this.time ? ' H:i:S' : '')
        return {
          altFormat: format,
          dateFormat: format,
          enableTime: this.time
        }
      }
    },
    watch: {
      date (value) {
        if (value && value.length) {
          this.$emit('input', value[0])
        }
      },
      value (value) {
        if (this.value) {
          this.date = [this.value]
        }
      }
    },
    props: {
      value: {
        type: [Date, String],
        required: false
      },
      time: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      isCleanable: {
        type: Boolean,
        default: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DateInput.vue?2a7e9225